export default "__VITE_ASSET__9870db8f__"